import React, { useEffect, useState, useRef } from "react";
import {
  Button,
  Col,
  Container,
  Form,
  Row,
  Spinner,
  Table,
} from "react-bootstrap";
import { ToastContainer } from "react-toastify";
import Pagination from "../Common/Pagination";
import moment from "moment";
import ExcelIcon from "../../Assets/ExcelIcon.svg"
import * as Icon from "react-bootstrap-icons";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useSelector } from "react-redux";

const NewBillAnalysis = () => {
  const selectedFinancialYear = useSelector((state) => state.activeData.financialYear);
  const activeKey = useSelector((state) => state.activeData?.activeNumberKey?.activeKey);
  const userState = useSelector(state => state?.loginData?.userData);
  // Variables for Zone-Gat Visitors Data ------------
  const [contractor, setContractor] = useState();
  const [TodayData, setTodayData] = useState();
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [startDateErr, setStartDateErr] = useState("");
  const [endDateErr, setEndDateErr] = useState("");
  const [loader, setLoader] = useState(true);
  const [currentloader, setCurrentLoader] = useState(true);

  const requestRef = useRef(0);
  const currentRequestRef = useRef(0);
  const prevYearRef = useRef(selectedFinancialYear);


  // States for Pagination ----------
  const [pageNo, setPageNo] = useState(1);
  const [docPerPage, setDocPerPage] = useState(50);
  const [noOfPages, setNoOfPages] = useState(0);


  // function for pagination

  const handlePageChange = (pageNumber) => {
    setPageNo(pageNumber);
  };

  const handleDocsPerPage = (docsPageProp) => {
    setPageNo(1);
    setDocPerPage(docsPageProp);
  };

  //   useEffect API Calls
  useEffect(() => {
    const isYearChanged = prevYearRef.current !== selectedFinancialYear;

    if (isYearChanged) {
      setStartDate("");
      setEndDate("");
      setPageNo(1);
      setContractor();
      setTodayData();
      prevYearRef.current = selectedFinancialYear;
    }

    getBillDistributionReport(isYearChanged ? "" : startDate, isYearChanged ? "" : endDate);
    getCurrentBillDistributionReport();
  }, [selectedFinancialYear]);

  // get List API
  const getBillDistributionReport = async (sDate = startDate, eDate = endDate) => {
    const requestId = ++requestRef.current;
    setLoader(true);
    try {
      const res = await fetch(
        process.env.REACT_APP_BASE_URL +
        "/billDistribution/zoneWiseReport",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            fromDate: sDate,
            toDate: eDate,
            financialYear: selectedFinancialYear,
            ...(userState?.usertype_keyname?.includes("zonalofficer") && {
              zonename: userState?.zonename
            })
          }),
        }
      );
      const response = await res.json();

      if (requestId !== requestRef.current) return;

      if (response.status === 200) {
        setContractor(response);
        setNoOfPages(response.noOfPages);
      }
    } catch (error) {
      if (requestId === requestRef.current) {
        setContractor();
      }
    } finally {
      if (requestId === requestRef.current) {
        setLoader(false);
      }
    }
  };

  const getCurrentBillDistributionReport = async () => {
    const requestId = ++currentRequestRef.current;
    setCurrentLoader(true);
    try {
      const res = await fetch(
        process.env.REACT_APP_BASE_URL +
        "/billDistribution/zoneWiseReport",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            fromDate: moment(new Date()).format("YYYY-MM-DD"),
            toDate: moment(new Date()).format("YYYY-MM-DD"),
            financialYear: selectedFinancialYear,
            ...(userState?.usertype_keyname?.includes("zonalofficer") && {
              zonename: userState?.zonename
            })
          }),
        }
      );
      const response = await res.json();

      if (requestId !== currentRequestRef.current) return;

      if (response.status === 200) {
        setTodayData(response);
        setNoOfPages(response.noOfPages);
      }
    } catch (error) {
      if (requestId === currentRequestRef.current) {
        setTodayData();
      }
    } finally {
      if (requestId === currentRequestRef.current) {
        setCurrentLoader(false);
      }
    }
  };

  // for export excel data
  const exportToExcel = () => {
    const wb = XLSX.utils.book_new();

    // Table headers
    const wsData = [
      [
        "Sr No.",
        "Zone Name",
        "Notice Count (Year)",
        "Mobile Verified Count (Year)",
        "Property Not Found Count (Year)",
        "Bill Issued Count (Year)",
        "Mahila's Worked Count (Year)",
        "Notice Count (Today)",
        "Mobile Verified Count (Today)",
        "Property Not Found Count (Today)",
        "Bill Issued Count (Today)",
        "Mahila's Worked Count"
      ]
    ];

    // Table rows
    contractor?.data?.forEach((row, index) => {
      wsData.push([
        pageNo !== 1 ? index + 1 + docPerPage * (pageNo - 1) : index + 1,
        row?.zone || "-",
        row?.noticeCount || 0,
        row?.mobileVerifiedCount || 0,
        row?.propertyNotFoundCount || 0,
        row?.propertyFoundCount || 0,
        row?.mahilaWorked || 0,
        TodayData?.data[index]?.noticeCount || 0,
        TodayData?.data[index]?.mobileVerifiedCount || 0,
        TodayData?.data[index]?.propertyNotFoundCount || 0,
        TodayData?.data[index]?.propertyFoundCount || 0,
        TodayData?.data[index]?.mahilaWorked || 0
      ]);
    });
    wsData.push([
      "Total",
      "",
      contractor?.totalNoticeCount || 0,
      contractor?.totalMobileVerifiedCount || 0,
      contractor?.totalPropertyNotFoundCount || 0,
      contractor?.totalPropertyFoundCount || 0,
      contractor?.totalMahilaWorked || 0, 
      TodayData?.totalNoticeCount || 0,
      TodayData?.totalMobileVerifiedCount || 0,
      TodayData?.totalPropertyNotFoundCount || 0,
      TodayData?.totalPropertyFoundCount || 0,
      TodayData?.totalMahilaWorked || 0
    ]);

    const ws = XLSX.utils.aoa_to_sheet(wsData);
    XLSX.utils.book_append_sheet(wb, ws, "Bill Analysis Report");

    const fileName = `BillAnalysis_${moment().format("YYYY-MM-DD")}.xlsx`;
    XLSX.writeFile(wb, fileName);
  };



  return (
    <div className="visitReport">
      <ToastContainer />
      <Container>
        <Row className="d-flex justify-content-end align-items-center">
          <Col md={2} className="mb-4 d-flex justify-content-end">
            <Button className="btn btn-submit" onClick={exportToExcel}>
              <Icon.CloudArrowDownFill className="me-2" size={20} />
              Excel Export
            </Button>
          </Col>
        </Row>
        <Row className="visitors mt-2">
          <div className="container tbl-container p-0">
            <div className="row tbl-fixed p-0" style={{ maxHeight: "65vh" }}>
              <Table responsive="lg" hover style={{ borderCollapse: 'collapse' }}>
                <thead>
                  <tr>
                    <th></th>
                    <th></th>
                    <th colSpan="6" className="text-center border-th">
                      Current Year
                    </th>
                    <th colSpan="6" className="text-center">
                      Today Count
                    </th>
                  </tr>
                  <tr>
                    <th>Sr No.</th>
                    <th>Zone Name</th>
                    <th>Notice Count</th>
                    {/* <th>Meeting Person Count</th> */}
                    <th>Mobile Verified Count</th>
                    <th>Property Not Found Count</th>
                    <th>Bill Issued Count</th>
                    <th >Mahila's Worked Count</th>
                    <th className="border-th">Palika Worked Count</th>
                    {/* <th>Property Not Found Count</th>
                    <th>Total Count</th> */}
                    {/* <th>Action</th> */}
                    <th>Notice Count</th>
                    <th>Mobile Verified Count</th>
                    <th>Property Not Found Count</th>
                    <th>Bill Issued Count</th>
                    <th>Mahila's Worked Count</th>
                    <th>Palika Worked Count</th>
                  </tr>
                </thead>
                <tbody>
                  {loader ? (
                    <tr>
                      <td colSpan={14} className="text-center">
                        <Spinner animation="border" variant="primary" />
                      </td>
                    </tr>
                  ) : (
                    contractor && contractor?.data !== undefined && contractor?.data !== null &&
                    contractor?.data?.length > 0 ? (
                      contractor?.data?.map((row, index) => {
                        return (
                          <tr key={index}>
                            <td className="border-tr-new">
                              {pageNo !== 1 ? (
                                <> {index + 1 + docPerPage * (pageNo - 1)}</>
                              ) : (
                                <>{index + 1}</>
                              )}
                            </td>
                            <td className="border-tr-new">{row?.zone ? row?.zone : "-"}</td>
                            <td className="border-tr-new">{row?.noticeCount ? row?.noticeCount : 0}</td>

                            {/* <td>{row?.meetingPersonCount ? row?.meetingPersonCount : 0 }</td> */}
                            <td className="border-tr-new">{row?.mobileVerifiedCount ? row?.mobileVerifiedCount : 0} </td>
                            <td className="border-tr-new">{row?.propertyNotFoundCount ? row?.propertyNotFoundCount : 0}</td>
                            <td className="border-tr-new">{row?.propertyFoundCount ? row?.propertyFoundCount : 0}</td>
                            <td className="border-tr-new">{row?.mahilaWorked ? row?.mahilaWorked : 0}</td>
                            <td className="border-tr-new">{row?.mahapalikaWorked ? row?.mahapalikaWorked : 0}</td>
                            {/* <td>{row?.propertyNotFoundCount ? row?.propertyNotFoundCount : 0 }</td>
                            <td>{row?.totalCount ? row?.totalCount : 0 }</td> */}
                            {/* <td>Action here</td> */}
                            <td className="border-tr-new">{TodayData?.data[index]?.noticeCount ? TodayData?.data[index]?.noticeCount : 0}</td>
                            <td className="border-tr-new">{TodayData?.data[index]?.mobileVerifiedCount ? TodayData?.data[index]?.mobileVerifiedCount : 0}</td>
                            <td className="border-tr-new">{TodayData?.data[index]?.propertyNotFoundCount ? TodayData?.data[index]?.propertyNotFoundCount : 0}</td>
                            <td className="border-tr-new">{TodayData?.data[index]?.propertyFoundCount ? TodayData?.data[index]?.propertyFoundCount : 0}</td>
                            <td className="border-tr-new">{TodayData?.data[index]?.mahilaWorked ? TodayData?.data[index]?.mahilaWorked : 0}</td>
                            <td className="border-tr-new">{TodayData?.data[index]?.mahapalikaWorked ? TodayData?.data[index]?.mahapalikaWorked : 0}</td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan={14} className="text-center">
                          No data found
                        </td>
                      </tr>
                    )
                  )}
                </tbody>
                <tfoot>
                  {contractor !== undefined && contractor?.data?.length > 0 ? (
                    <tr className="sum-row">
                      <td colSpan="2">
                        <strong className="m-2">Total Counts :-</strong>
                      </td>
                      <td className="border-th-new">
                        <strong>
                          {contractor && contractor.totalNoticeCount !== undefined && contractor.totalNoticeCount !== null
                            ? contractor.totalNoticeCount
                            : "0"}
                        </strong>
                      </td>
                      {/* <td>
                        <strong>{contractor.totalMeetingPersonCount ? contractor.totalMeetingPersonCount : '0'}</strong>
                      </td> */}
                      <td className="border-th-new">
                        <strong>
                          {contractor && contractor.totalMobileVerifiedCount !== undefined && contractor.totalMobileVerifiedCount !== null
                            ? contractor.totalMobileVerifiedCount
                            : "0"}
                        </strong>
                      </td>
                      <td className="border-th-new">
                        <strong>
                          {contractor && contractor.totalPropertyNotFoundCount !== undefined && contractor.totalPropertyNotFoundCount !== null
                            ? contractor.totalPropertyNotFoundCount
                            : "0"}
                        </strong>
                      </td>
                      <td className="border-th-new">
                        <strong>
                          {contractor && contractor.totalPropertyFoundCount !== undefined && contractor.totalPropertyFoundCount !== null
                            ? contractor.totalPropertyFoundCount
                            : "0"}
                        </strong>
                      </td>
                      <td className="border-th">
                        {/* totalMahilaWorked */}
                        <strong>
                          {""}
                          {contractor && contractor.totalMahilaWorked !== undefined && contractor.totalMahilaWorked !== null
                            ? contractor.totalMahilaWorked
                            : "0"}
                        </strong>
                      </td>
                      <td className="border-th">
                        {/* totalMapalikaWorked */}
                        <strong>
                          {""}
                          {contractor && contractor.totalMahapalikaWorked !== undefined && contractor.totalMahapalikaWorked !== null
                            ? contractor.totalMahapalikaWorked
                            : "0"}
                        </strong>
                      </td>
                      {/* <td>
                        <strong>{contractor.totalPropertyNotFoundCount ? contractor.totalPropertyNotFoundCount : '0'}</strong>
                      </td>
                      <td>
                        <strong>{contractor.totalVisits ? contractor.totalVisits : '0'}</strong>
                      </td> */}

                      <td className="border-th-new">
                        <strong>
                          {TodayData && TodayData?.totalNoticeCount !== undefined && TodayData?.totalNoticeCount !== null
                            ? TodayData?.totalNoticeCount
                            : "0"}
                        </strong>
                      </td>
                      <td className="border-th-new">
                        <strong>
                          {TodayData && TodayData?.totalMobileVerifiedCount !== undefined && TodayData.totalMobileVerifiedCount !== null
                            ? TodayData.totalMobileVerifiedCount
                            : "0"}
                        </strong>
                      </td>
                      <td className="border-th-new">
                        <strong>
                          {TodayData && TodayData.totalPropertyNotFoundCount !== undefined && TodayData.totalPropertyNotFoundCount !== null
                            ? TodayData.totalPropertyNotFoundCount
                            : "0"}
                        </strong>
                      </td>
                      <td className="border-th-new">
                        <strong>
                          {TodayData && TodayData.totalPropertyFoundCount !== undefined && TodayData.totalPropertyFoundCount !== null
                            ? TodayData.totalPropertyFoundCount
                            : "0"}
                        </strong>
                      </td>
                      <td className="border-th-new">
                        <strong>
                          {""}
                          {TodayData && TodayData.totalMahilaWorked !== undefined && TodayData.totalMahilaWorked !== null
                            ? TodayData.totalMahilaWorked
                            : "0"}
                        </strong>
                      </td>
                      <td className="border-th">
                        {/* totalMapalikaWorked */}
                        <strong>
                          {""}
                          {TodayData && TodayData.totalMahapalikaWorked !== undefined && TodayData.totalMahapalikaWorked !== null
                            ? TodayData.totalMahapalikaWorked
                            : "0"}
                        </strong>
                      </td>
                    </tr>
                  ) : null}
                </tfoot>
              </Table>
            </div>
            {/* <Row>
                <Col md={4} className="d-flex align-items-center mt-3 mt-md-0">
                  <h6 className="text-start mb-0">
                    <Icon.People className="me-2" />
                    Total - <strong>{contractor?.count}</strong>
                  </h6>
                </Col>
                <Col md={8} className="d-flex justify-content-end">
                  <Pagination
                    currentPage={pageNo}
                    totalPages={noOfPages}
                    onPageChange={handlePageChange}
                    onDocsPerPage={handleDocsPerPage}
                    docsPerPage={docPerPage}
                  />
                </Col>
              </Row> */}
          </div>
        </Row>
      </Container >
    </div >
  );
};

export default NewBillAnalysis;
